import {Component, inject, AfterViewInit, OnDestroy} from '@angular/core';
import {
  ContentComponent,
  ExplorerService,
  TreeComponent,
  DataService,
  BreadcrumbsComponent,
  IconsComponent,
  ListComponent,
  ExplorerComponent
} from 'filemanager-explorer';
import {map, tap, Subscription, filter, firstValueFrom} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {MaterialModule} from '@app/material.module';
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ExplorerEntity} from '@interfaces/explorer-entity';
import { FilemanagerService } from '@app/core/services/filemanager/filemanager.service';
import { RagStatusPollingService } from '@app/core/services/filemanager/rag-status-polling.service';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { DocumentsHomeComponent } from '@pages/filemanager/documents-home/documents-home.component';
import { CompanyFilterComponent } from '@components/company-filter/company-filter.component';
import { CompanyFilterService } from '@services/company-filter/company-filter.service';
import { distinctUntilChanged, skip } from 'rxjs';

@Component({
  selector: 'app-filemanager',
  imports: [ExplorerComponent, MaterialModule, TranslateModule, TablerIconsModule, DocumentsHomeComponent, CompanyFilterComponent],
  standalone: true,
  templateUrl: './filemanager.component.html',
  styleUrl: './filemanager.component.scss',
  providers: [RagStatusPollingService],
})
export class FilemanagerComponent implements AfterViewInit, OnDestroy {

  public _explorerService = inject(ExplorerService);
  public fileManagerService: FilemanagerService = inject(FilemanagerService);
  private ragStatusPolling = inject(RagStatusPollingService);

  protected openedDir$ = this._explorerService.openedDir$.pipe(map((p) => p?.data['name']));
  protected selectionLength$ = this._explorerService.selection$.pipe(map((s) => s.length));
  protected rootLen$ = this._explorerService.root$.pipe(map((r) => r.children.length));


  // Sottoscrizione al file aperto. ExplorerService è un singleton (providedIn:
  // 'root'), quindi la teniamo tracciata e la chiudiamo in ngOnDestroy: senza
  // questo, ogni visita alla pagina lasciava una subscription viva e il doppio
  // click apriva la modale del documento tante volte quante le visite.
  private openFileSub: Subscription = this._explorerService.openFile$.subscribe((f: any) => {
    if (f && f?.isLeaf && f?.data) {
      // in this case is double clicked on a file
      // confirm('double clicked on a file '+ f['name']);
      this.fileManagerService.editFile(f.data)
      // this.selection.emit([f])
    }
  });

  constructor() {
    // this.explorerService.openTree({ id: 15, name: 'Aerosmith', path: '/Music/Rock/' });
    // Avvia l'osservazione dello stato RAG: pollerà (senza loader) solo quando
    // nella cartella corrente c'è un documento in 'pending'.
    this.ragStatusPolling.init();
    this._explorerService.openNode();
  }

  // Another company chosen while browsing its folders: back to the top level of the new one
  private companySub: Subscription = inject(CompanyFilterService).documentsCompany$
    .pipe(distinctUntilChanged(), skip(1))
    .subscribe(() => {
      if (this.view === 'explorer') {
        this._explorerService.openNode();
      }
    });

  /** 'home' = sections by use with the date filter, 'explorer' = the full folder browser */
  view: 'home' | 'explorer' = 'home';

  showHome(): void {
    this.view = 'home';
  }

  async browse(folderId?: number): Promise<void> {
    this.view = 'explorer';
    if (folderId === undefined) {
      this._explorerService.openNode();
      return;
    }
    // Explorer nodes have their own ids: find the node of this folder among the root's children
    let root = await firstValueFrom(this._explorerService.root$);
    if (!root.children.length) {
      this._explorerService.openNode();
      root = await firstValueFrom(this._explorerService.root$.pipe(filter(r => r.children.length > 0)));
    }
    const node = root.children.find(child => (child.data as ExplorerEntity)?.id === folderId);
    this._explorerService.openNode(node?.id);
  }

  customMenuItems = [
    {
      icon: 'add',
      tooltip: 'Test Button',
      callback: () => this.customAction()
    }
  ];

  ngAfterViewInit() {
    setTimeout(() => {
      // Esegui l'operazione di apertura della cartella
      // this._explorerService.openNode();
      this._explorerService.root$.subscribe((root) => {
        //console.log('Root:', root);
      });
    }, 500);
  }

  ngOnDestroy() {
    this.openFileSub.unsubscribe();
    this.companySub.unsubscribe();
    // Reset del file aperto sul singleton: evita che al rientro nella pagina il
    // BehaviorSubject riproponga l'ultimo file e riapra la modale da solo.
    this._explorerService.openFile(undefined);
  }

  onCustomAction(entity:ExplorerEntity) {
    //console.log("entity: ", entity);
  }

  customAction(){

  }

}
